/**
 * HELPER_PROVIDERS
 */
import { AuthGuard } from './auth-guard';

export const HELPER_PROVIDERS: any[] = [AuthGuard];
